import { useEffect, useState } from "react";
import { GET_BANNERS } from "../api/constants";

const useBanners = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(GET_BANNERS);
        const data = await response.json();

        // ✅ tolerate different API shapes
        if (Array.isArray(data?.data)) {
          setBanners(data.data);
        } else if (Array.isArray(data)) {
          setBanners(data);
        } else {
          setBanners([]);
        }
      } catch (err) {
        console.error("Error fetching banners:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  return { banners, loading, error };
};


export default useBanners;
